import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConstants } from '../../constants/app-constants';
import { AppRouters } from '../../constants/app-routers.router';
import { KeyStorage } from '../../constants/key-storage.stor';
import { AppStorageService } from '../../services/store/app-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private storage: AppStorageService) { }

  canActivate(): boolean {
    // const token = localStorage.getItem(KeyStorage.keyLocalToken);
    const token = this.storage.getItem<string>(KeyStorage.keyLocalToken);
    console.warn(token);

    if (token) {
      // مسجل دخول → يسمح بالدخول
      return true;
    } else {
      // غير مسجل دخول → يوجه إلى صفحة تسجيل الدخول
      this.router.navigate([AppRouters.auth_SignIn]);
      return false;
    }
  }
}
